import React, { FC } from "react"
import { Loader, Stack, Text } from "@mantine/core"
import { useLanguage } from "../../contexts/language-context"

type FullscreenLoaderProps = {
    label?: string
}

export const FullscreenLoader: FC<FullscreenLoaderProps> = ({ label }) => {
    const { L } = useLanguage()

    return (
        <Stack align="center" justify="center" spacing="xl" sx={{ position: "absolute", inset: 0 }}>
            <Loader size="xl" />
            <Text color="dimmed">{label ?? L("Loading") + "..."}</Text>
        </Stack>
    )
}
